// Set at magic login when the learner has never been active (lastActivity is
// null). The tour reads it on the next layout page and clears it on finish/skip.
export const ONBOARDING_TOUR_PENDING_KEY = "onboardingTourPending";

// Dispatched on window to replay the tour on demand (e.g. from the avatar menu).
export const START_ONBOARDING_TOUR_EVENT = "mple:start-onboarding-tour";

export const markOnboardingTourPending = () => {
  try {
    localStorage.setItem(ONBOARDING_TOUR_PENDING_KEY, "true");
  } catch {
    // Storage unavailable: the tour is optional, so skip it silently.
  }
};

export const isOnboardingTourPending = () => {
  try {
    return localStorage.getItem(ONBOARDING_TOUR_PENDING_KEY) === "true";
  } catch {
    return false;
  }
};

export const clearOnboardingTourPending = () => {
  try {
    localStorage.removeItem(ONBOARDING_TOUR_PENDING_KEY);
  } catch {
    // ignore
  }
};

export const requestOnboardingTour = () => {
  window.dispatchEvent(new Event(START_ONBOARDING_TOUR_EVENT));
};
